import styles from './FormActions.module.css';

export default function FormActions({
  children,
}: {
  children: React.ReactNode;
}) {
  return <div className={styles.container}>{children}</div>;
}
